(function () {
  var popupSelector = '.jdgm-popup-widget';
  var cardSelector = '.jdgm-popup-card';
  var customId = 'rt-jdgm-floating-review';
  var reviews = [];
  var activeIndex = 0;
  var showTimer = null;
  var hideTimer = null;
  var closedUntil = 0;

  function textFrom(root, selector) {
    var el = root && root.querySelector(selector);
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function starCount(card) {
    var count = card.querySelectorAll('.jdgm-popup-card__rev-rating .jdgm--on, .jdgm-popup-card__rev-rating .jm-star-rating__font-icon').length;
    return Math.max(1, Math.min(count || 5, 5));
  }

  function collectReviews() {
    var cards = Array.prototype.slice.call(document.querySelectorAll(cardSelector));
    var next = cards.map(function (card) {
      return {
        reviewer: textFrom(card, '.jdgm-popup-card__reviewer') || 'Verified customer',
        title: textFrom(card, '.jdgm-popup-card__rev-title'),
        body: textFrom(card, '.jdgm-popup-card__rev-body') || textFrom(card, '.jdgm-popup-card__rev-content'),
        product: textFrom(card, '.jdgm-popup-card__prod-title'),
        stars: starCount(card)
      };
    }).filter(function (review) {
      return review.body || review.title || review.product;
    });

    if (next.length) reviews = next;
    return reviews.length > 0;
  }

  function hideNativePopup() {
    var popup = document.querySelector(popupSelector);
    if (popup) popup.classList.add('rt-jdgm-native-hidden');
  }

  function ensureCard() {
    var card = document.getElementById(customId);
    if (card) return card;

    card = document.createElement('div');
    card.id = customId;
    card.className = 'rt-jdgm-floating-review';
    card.setAttribute('aria-live', 'polite');
    card.innerHTML = [
      '<button class="rt-jdgm-floating-review__close" type="button" aria-label="Close review popup">&times;</button>',
      '<div class="rt-jdgm-floating-review__stars" aria-hidden="true"></div>',
      '<div class="rt-jdgm-floating-review__reviewer"></div>',
      '<div class="rt-jdgm-floating-review__title"></div>',
      '<p class="rt-jdgm-floating-review__body"></p>',
      '<div class="rt-jdgm-floating-review__product"></div>'
    ].join('');

    card.querySelector('.rt-jdgm-floating-review__close').addEventListener('click', function () {
      closedUntil = Date.now() + 60000;
      hideCard();
    });

    document.body.appendChild(card);
    return card;
  }

  function setReview(card, review) {
    card.querySelector('.rt-jdgm-floating-review__stars').textContent = new Array(review.stars + 1).join(String.fromCharCode(9733));
    card.querySelector('.rt-jdgm-floating-review__reviewer').textContent = review.reviewer;
    card.querySelector('.rt-jdgm-floating-review__title').textContent = review.title;
    card.querySelector('.rt-jdgm-floating-review__title').style.display = review.title ? 'block' : 'none';
    card.querySelector('.rt-jdgm-floating-review__body').textContent = review.body;
    card.querySelector('.rt-jdgm-floating-review__body').style.display = review.body ? '-webkit-box' : 'none';
    card.querySelector('.rt-jdgm-floating-review__product').textContent = review.product;
    card.querySelector('.rt-jdgm-floating-review__product').style.display = review.product ? '-webkit-box' : 'none';
  }

  function hideCard() {
    var card = document.getElementById(customId);
    if (card) card.classList.remove('is-visible');
    if (hideTimer) window.clearTimeout(hideTimer);
  }

  function showCard() {
    if (Date.now() < closedUntil) return;
    if (!collectReviews()) return;
    hideNativePopup();

    var card = ensureCard();
    setReview(card, reviews[activeIndex % reviews.length]);
    activeIndex += 1;
    card.classList.add('is-visible');

    if (hideTimer) window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(function () {
      card.classList.remove('is-visible');
    }, 8500);
  }

  function start() {
    if (!collectReviews()) return;
    hideNativePopup();
    if (showTimer) return;
    window.setTimeout(showCard, 3500);
    showTimer = window.setInterval(showCard, 14000);
  }

  function watch() {
    start();
    var observer = new MutationObserver(function () {
      collectReviews();
      hideNativePopup();
      start();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    [1200, 3000, 6000, 10000].forEach(function (delay) {
      window.setTimeout(start, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
